export default [
    {
        path: '/owners/calendar/:propertyId(\\d+)?/:date(\\d{4}-\\d{2}-\\d{2})?',
        components: {
            default: () => import(/* webpackChunkName: "owners.properties.calendar" */ '@/views/Owners/Properties/Calendar.vue'),
            mainMenu: () => import(/* webpackChunkName: "main.menu" */ '@/menus/Main/Main.vue'),
            startMenu: () => import(/* webpackChunkName: "owners.start.menu" */ '@/menus/Start/Owners.vue'),
        },
        meta: {
            group: '/owners/calendar',
            label: 'Calendar',
            resetBackButton: true,

            // used in the scroll behavior
            _scrollPath: '/owners/calendar/:propertyId/:date',
            
            scrollBehavior(to, from) {
                if (
                    (to.meta._scrollPath == from.meta._scrollPath) &&
                    (to.params.propertyId == from.params.propertyId)
                ) {
                    return false;
                }
                return null;
            },

            multiRoute: 'owners.calendar',
        }
    },

    {
        path: '/owners/service-level/:year(\\d+)/:propertyId(\\d+)',
        components: {
            default: () => import(/* webpackChunkName: "owners.properties.details" */ '@/views/Owners/Properties/ServiceLevelEnrollement.vue'),
            mainMenu: () => import(/* webpackChunkName: "main.menu" */ '@/menus/Main/Main.vue'),
            startMenu: () => import(/* webpackChunkName: "owners.start.menu" */ '@/menus/Start/Owners.vue'),
        },
        meta: {
            stepsTab: 'property-details',
            group: '/owners/property-details',
            label: 'Property Details',
            multiRoute: 'owners.properties.details',
        }
    },

    {
        path: '/owners/schedule-inspection/:propertyId(\\d+)?',
        components: {
            default: () => import(/* webpackChunkName: "owners.properties.inspection" */ '@/views/Owners/Properties/ScheduleInspection.vue'),
            mainMenu: () => import(/* webpackChunkName: "main.menu" */ '@/menus/Main/Main.vue'),
            startMenu: () => import(/* webpackChunkName: "owners.start.menu" */ '@/menus/Start/Owners.vue'),
        },
        meta: {
            group: '/owners/property-inspection',
            label: 'Schedule Property Inspection',
            multiRoute: 'owners.properties.inspection',
        }
    },
];
